export const REJECT_MENTION_REASON_PRESETS = [
  "Brand not present",
  "Program / channel name, not a brand",
  "Common word, not the brand",
  "Wrong brand match",
  "Not a YouTube program",
  "Organic / not a sponsor",
  "Not a banner",
  "Not a curtain",
  "Not a closing credit",
  "Duplicate",
] as const;

export const DEFAULT_REJECT_REASON = "Brand not present";

/** Alias for credit/curtain overlap rejects (same taxonomy pill). */
export const DUPLICATE_CREDIT_REJECT_REASON = "Duplicate";
